var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shell"}},[_c('iframe',{attrs:{"src":_vm.urls.shell + '?site=' + _vm.site + '&client=' + _vm.user}})])
}
var staticRenderFns = []

export { render, staticRenderFns }